export default ['$scope', 'calendar', function($scope, calendar) {
  this.calendar = calendar.create();

  this.active = this.openLayout ? true : false;

  $scope.$watch('ctrl.blockWeekends', block => {
    this.calendar.blockWeekends = block;
  });

  $scope.$watch('ctrl.startDate', date => {
    if (date) this.calendar.startDate = date;
  });

  $scope.$watch('ctrl.endDate', date => {
    if (date) this.calendar.endDate = date;
  });

  $scope.$watch('ctrl.date', date => {
    if (date) this.calendar.currentDate = date;
  });

  this.humanizeMonth = () => {
    return moment.months()[this.calendar.currentMonth];
  }

  $scope.toggleActive = () => {
    if (this.openLayout) { return; }
    angular.element(document).find('.calendar-input input.focused').focus();
    return this.active = !this.active;
  };

  $scope.selectDate = date => {
    if (date.invalid) { return; }
    this.selectedDate = date.value;
    this.calendar.currentDate
    this.onSelected(date);
    if (!this.openLayout) { return this.active = false; }
  };

  $scope.forward = () => {
    this.calendar.nextMonth();
  };

  $scope.backward = () => {
    this.calendar.prevMonth();
  };

  this.disableBackward = () => {
    return this.calendar.isFirstMonth;
  }

  this.disableForward = () => {
    return this.calendar.isLastMonth;
  }

  return this;
}
];
